import Axios from 'axios'
import store from '../store'

const event = {
  getFreeRoomUrl() {
    return process.env.VUE_APP_URL_SERVER_BASE_FREEROOM
  },
  getClientIdFreeroom() {
    return store.getters['Client/clientIdFreeroom']
  },
  checkout(roomId, eventId, start, finish) {
    return Axios.patch(`${this.getFreeRoomUrl()}/api/public/clients/${this.getClientIdFreeroom()}/rooms/${roomId}/events/${eventId}/checkout?start=${start}&end=${finish}`, {
      ignoreGlobalCatch: true,
    })
  }
}

export default event
